<app-header></app-header>
<div #shopenergy class="commercial-getstarted">
    <main role="main" class="maincnt mainmrg">
      <div class="getbannersect sectppad pb-2" id="getStartPage">
        <div class="sectpad container">
          <ul class="navigate nav">
            <li><a href="javascript:void(0)" id="link_1" (click)="getslide(shopenergy)"></a></li>
            <li><a href="javascript:void(0)" id="link_2" (click)="getslide(onestop)"></a></li>
            <li><a href="javascript:void(0)" id="link_3" (click)="getslide(recommendation)"></a></li>
            <li><a href="javascript:void(0)" id="link_4" (click)="getslide(signup)"></a></li>
          </ul>
         
          
          <div #shopenergy id="shopenergy" class="col-12 row m-0 sections pl-0">
            <div class="bannertext col-sm-8 mt-3">
              <h1>Shop for Energy<br/>
                Save with Confidence</h1>
              <div class="desc webview bannerdesc mblnhgt mt-2 mob-mt-0">Energy service for business owners, operators <br> and investors powered by AI </div>
              <div class="desc mobileview bannerdesc mblnhgt mt-2 mob-mt-0">Energy service for business<br>owners, operators and investors<br>powered by AI </div>              
            </div>
            <div class="col-sm-4 bannerimg drag-drop mb-4 text-right mob-center mob-mb-0">
              <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482837/Static%20images/Commercial-getStarted/commercial-hi_nwqf4z.svg" alt="Illustration of the word Hi in purple" title="Hi illustration" width="280" />
            </div>
          </div>
        </div>
      </div>
      <div #onestop id="onestop" class="onesect sections">
        <div class="sectpad container pt-4 text-center">
          <div class="row">
          <div class="col-sm-3 col-12 subsect text-center pb-3 mt-4 drag-drop mob-mt-0">
            <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482900/Static%20images/Commercial-getStarted/commercial-onestopimg_qvtxwt.svg" class="img-responsive" width="220" alt="Shopping cart illustration in commercial energy purple background" title="Shopping cart illustration">
          </div>
          <div class="bannertext col-sm-9 col-12 pt-4 subsect text-right">
            <h1 class="mt-4 pt-5 mob-pt-0">One Stop,<br>
              Comparison Shop</h1>
            <div class="desc webview bannerdesc mblnhgt mt-2 mob-mt-0">Leverage our purchasing power and<br> portfolio to your financial gain</div>
            <div class="desc mobileview bannerdesc mblnhgt mt-2 mob-mt-0">Leverage our purchasing<br>power and portfolio to your<br>financial gain</div>            
          </div>
        </div>
        </div>
      </div>
      <div #recommendation id="recommendation" class="recommendatesect sections">
        <div class="sectpad container">
          <div class="row">
          <div class="bannertext col-sm-7 col-12 subsect textsec getpadd">
            <h1 class="mt-4 pt-4">Get an Honest
              Recommendation</h1>
              <div class="desc webview bannerdesc mblnhgt mt-2 mob-mt-0">Eva, our delightful AI bot, will recommend energy plans that fit your business needs and usage profile</div>
              <div class="desc mobileview bannerdesc mblnhgt mt-2 mob-mt-0">Eva, our delightful AI bot, will<br>recommend energy plans that fit your<br>business needs and usage profile</div>              
            </div>
          <div class="col-sm-5 col-12 subsect pt-4 imgsec drag-drop mb-4 text-right mob-center">
            <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569482952/Static%20images/Commercial-getStarted/commercial-recommendationimg_rhqsie.svg" alt="Charcoal Eva logo in commercial energy purple background" title="Charcoal Eva logo in commercial energy purple background" width="245" />
          </div>
      </div>
  
        </div>
      </div>
      <div #signup id="signup" class="signupsect pb-5 sections">
        <div class="sectpad container text-center">
          <div class="row">
          <div class="col-sm-3 col-12 signupimg pt-0 imgsec drag-drop pt-4 mob-pt-0">
            <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569483068/Static%20images/Commercial-getStarted/commercial-signupimg_fldrmm.svg" alt="Illustration of lightbulb looking like a piggy bank" title="Lightbulb bank illustration" width="238" />
          </div>
          <div class="bannertext col-sm-9 col-12 mt-5 mob-mt-20 subsect text-right textsec pt-5">
            <h1 class="mt-3">Sign up & <br>
            Start Saving</h1>
            <div class="desc webview bannerdesc mblnhgt mt-2 mob-mt-0">Expert advice at your fingertips. What are you waiting for?</div>
            <div class="desc mobileview bannerdesc mblnhgt mt-2 mob-mt-0">Expert advice at your fingertips.<br>What are you waiting for?</div>            
            <div class="col-sm-12 subsect p-0 text-right signupget mb-5 mt-4 webview">
              <a class="btn btn-black mb-3 p-2 font22 float mbright" style = 'position: fixed;display: block;bottom:0px;right: 29px;' id = 'myBtn1' (click)="getQuestionnaire()"  href="javascript:void(0)">GET STARTED</a>
            </div>
          </div>
        </div>
          <div class="col-sm-12 subsect p-0 text-right signupget mb-5 mobileview mbflt">
            <a class="btn btn-black mb-3 p-2 font19 mbright getstart-shadow" (click)="getQuestionnaire()" href="javascript:void(0)" >GET STARTED</a>
          </div>
        </div>
      </div>
      
    </main>
  </div>